import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ProductService } from 'src/app/services/core/services/product-services/product.service';
@UntilDestroy()

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {

  companyForm!: FormGroup
  submitted = false;
  selectedServices: any = '';
  status = true
  spacetypes: any
  profileImageURL: string | null = null;
  selectedFile: ImageSnippet | null = null;
  timezones: any;
  companyId:any;
  syncToken:any;
  genericId:any
  accounts: any[] = [];
  selectedPayAccount: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private productService: ProductService,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit(): void {

     this.companyForm = this.fb.group({
      CompanyName: ['', Validators.required],
      CompanyAddr: this.fb.group({
        Line1: [''],
        Line2: [''],
        City: [''],
        CountrySubDivisionCode: [''],
        PostalCode: [''],
        Country: [''],
      }),
      reference: this.fb.group({
        name: [''],
        id: [''],
        url: [''],
      }),
      isAutoSync: [true],
      isAutoBillPay: [false],
      billPayAccount: this.fb.group({
        name: [''],
        value: [''],
        payType: ['Check']
      })
    });

    
      this.activatedRoute.params
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        this.companyId = params['id'];
        if (this.companyId) {
          this.getCompanyById();
          this.getAccounts();
        }
    });
    this.timezones = moment.tz.names();
  }


  get form() {
    return this.companyForm.controls;
  }

  get address() {
    return this.companyForm.get('CompanyAddr') as FormGroup;
  }

  get reference() {
    return this.companyForm.get('reference') as FormGroup;
  }

  onSave() {
    this.submitted = true;
    if (this.companyForm.invalid) {
      return;
    }
    const payload = this.companyForm.value;
    if (!payload.isAutoSync) {
      payload.isAutoBillPay = false;
      payload.billPayAccount = { name: '', value: '', payType: 'Check' };
    } else if (!payload.isAutoBillPay) {
      payload.billPayAccount = { name: '', value: '', payType: 'Check' };
    }

    if(this.companyId){
        payload.SyncToken = this.syncToken,
        payload.Id =  this.genericId
    }


    this.companyService.saveComanies(this.companyId, payload).pipe(untilDestroyed(this)).subscribe(
      (data) => {
        if (data) {
          this.router.navigateByUrl("companies");
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );

  }

  onSelectAddress(place: any): void {
    
    const selectedAddress = place.address_components;
    // city
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';

    // state
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.short_name : '';

      // Postal Code
  const postalCode = selectedAddress.find((data: any) =>
    data.types.includes('postal_code')
  );
  const postalCodeValue = postalCode ? postalCode.long_name : '';

  // Country
  const country = selectedAddress.find((data: any) =>
    data.types.includes('country')
  );
  const countryName = country ? country.long_name : ''; 

    this.companyForm.patchValue({
      CompanyAddr: {
        City: cityName,
        PostalCode:postalCodeValue,
        Country:countryName,
        CountrySubDivisionCode: stateName,
        Line1: place.formatted_address,
        Line2: place.formatted_address
      }
    });


  }

   toggleAutoSync(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.companyForm.patchValue({ isAutoSync: isChecked });
    if (!isChecked) {
      this.companyForm.patchValue({
        isAutoBillPay: false,
        billPayAccount: { name: '', value: '', payType: 'Check' }
      });
      this.selectedPayAccount = null;
    }
  }

  toggleAutoBillPay(event: Event) {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;
    if (isChecked && !this.companyForm.get('isAutoSync')?.value) {
      input.checked = false;
      this.companyForm.patchValue({ isAutoBillPay: false });
      sweetAlert('Auto Sync required', 'Turn on Auto Sync first to enable Auto Bill Pay.', 'info', 'Ok');
      return;
    }
    this.companyForm.patchValue({ isAutoBillPay: isChecked });
    if (!isChecked) {
      this.companyForm.patchValue({
        billPayAccount: { name: '', value: '', payType: 'Check' }
      });
      this.selectedPayAccount = null;
    }
  }

  getAccounts() {
    if (!this.companyId) return;
    this.productService.getAccount(this.companyId, { forPayment: 'true' })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        this.accounts = Array.isArray(data) ? data : (data?.Id ? [data] : (data?.results || []));
        const selectedId = this.companyForm.get('billPayAccount.value')?.value;
        if (selectedId) {
          this.selectedPayAccount = this.accounts.find((account: any) => account.Id === selectedId);
        }
      });
  }

  onPayAccountChange(event: Event) {
    const selectedId = (event.target as HTMLSelectElement).value;
    const selectedAccount = this.accounts?.find((account: any) => account.Id === selectedId);
    if (!selectedAccount) {
      this.companyForm.patchValue({
        billPayAccount: { name: '', value: '', payType: 'Check' }
      });
      return;
    }
    this.selectedPayAccount = selectedAccount;
    this.companyForm.patchValue({
      billPayAccount: {
        name: selectedAccount.Name,
        value: selectedAccount.Id,
        payType: selectedAccount.AccountType === 'Credit Card' ? 'CreditCard' : 'Check'
      }
    });
  }

  getCompanyById() {
    this.companyService.getCompanyById(this.companyId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.syncToken = data.SyncToken;
        this.genericId = data.Id; 
        this.companyForm.patchValue({
          ...data,
          isAutoBillPay: !!data.isAutoBillPay,
          billPayAccount: {
            name: data.billPayAccount?.name || '',
            value: data.billPayAccount?.value || '',
            payType: data.billPayAccount?.payType || 'Check'
          }
        });
        this.getAccounts();
      }
    })
  }

}
